<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-25T15:08:56+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe - Career page with a list of vacancies
@Last modified by:   tom
@Last modified time: 2019-06-07T13:21:19+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved
-->

<template>

  <c-page
    id="career"
    :title="$t('career.header.title')"
    :jbheader="$t('career.header.subtitle')"
    :jblead="$t('career.header.lead')"
    jbvariant="primary"
    :sideimage="require('@/assets/img/career/team.jpg')">

    <!-- Intro -->
    <!-- <p v-html="$t('career.intro')"/> -->

    <!-- Vacancy -->
    <h2 class="text-secondary">{{ $t('career.vacancies.title') }}</h2>
    <p v-html="$t('career.vacancies.payload')"/>

    <!-- Job list  -->
    <div role="tablist">
      <b-card
        v-for="i in ['M06','U01','T28','T31','ALL']"
        :key = "i"
        no-body
        class="mb-2">
        <b-card-header role="tab" class="mb-0 pr-0 pl-0 pt-0 pb-0">
          <b-btn
            v-b-toggle="'accordion' + i"
            block
            href="#"
            variant="white"
            class="text-left">
            {{ i + ' - ' + $t( 'career.jobs.' + i + '.jobtitle') }}
          </b-btn>
        </b-card-header>
        <b-collapse :id="'accordion' + i" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <h4 class="text-secondary">{{ $t( 'career.jobs.' + i + '.description') }}</h4>
            <blockquote v-if="$te( 'career.jobs.' + i + '.quote', 'en')">
              {{ $t( 'career.jobs.' + i + '.quote') }}
            </blockquote>

            <!-- tasks -->
            <h5 class="text-primary">
              <!-- check if we have override of the default labels, if not use default -->
              {{ $te('career.jobs.' + i + '.label', 'en') ? $t('career.jobs.' + i + '.label.tasks') : $t( 'career.jobs.label.tasks') }}
            </h5>
            <uli :labelkey="'career.jobs.' + i + '.tasks'" class="text-center"/>

            <!-- require -->
            <h5 class="text-primary">
              {{ $te('career.jobs.' + i + '.label', 'en') ? $t('career.jobs.' + i + '.label.require') : $t( 'career.jobs.label.require') }}
            </h5>
            <uli :labelkey="'career.jobs.' + i + '.require'" icon="plus" class="text-center"/>

            <!-- location -->
            <h5 class="text-primary">
              {{ $te('career.jobs.' + i + '.label', 'en') ? $t('career.jobs.' + i + '.label.location') : $t( 'career.jobs.label.location') }}
            </h5>
            <uli :labelkey="'career.jobs.' + i + '.location'" icon="map-marker" class="text-center"/>

            <p v-if="$te( 'career.jobs.' + i + '.note', 'en')"
               v-html="$t( 'career.jobs.' + i + '.note') "/>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>

    <!-- contact us -->
    <p v-html="$t('career.incentive')"/>
    <b-btn to="/#contact" v-html="$t('contact.title')"/>
  </c-page>

</template>

<script>
export default {
  name: 'Career'
}
</script>

<style lang="scss" scoped>
</style>
